import axios, { AxiosHeaders } from "axios";
import config from "../config";

const API_BASE_URL = config.API_BASE_URL || process.env.REACT_APP_API_URL as String;

// Create Axios instance
const api = axios.create({
  baseURL: API_BASE_URL.toString(),
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor (for token authentication)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("us_st_d");

    // Ensure headers exist before modifying them
    if (!config.headers) {
      config.headers = new AxiosHeaders(); // Initialize headers if undefined
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error), // Handle errors
);

// Add response interceptor (for error handling)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Unauthorized! Redirecting to login...");
      localStorage.removeItem("us_st_d");
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

export default api;
